import { replacePlaceholderInUrl } from "@jog/shared"
import { LinkProps } from "next/dist/client/link"
import NextLink from "next/link"
import { AnchorHTMLAttributes, PropsWithChildren, forwardRef } from "react"

interface AppLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement>, Omit<LinkProps, "href"> {
    to?: string
    href?: string
    external?: boolean
    color?: string
}

export const Link = forwardRef<HTMLAnchorElement, PropsWithChildren<AppLinkProps>>(
    ({ children, href, to, external = false, ...other }: PropsWithChildren<AppLinkProps>, ref) => {
        const sites = process.env.NEXT_PUBLIC_SITE_URL || ""
        // if (!to && !href) {
        //     logger.error("Link must have either a `to` or `href` prop.")
        //     return null
        // }
        if (to && !href) {
            href = to
        }
        // Check if it is a relative link from the CMS
        if (href !== undefined && href !== null) {
            // Replace hard-coded domains also, as this makes testing impossible.
            href = replacePlaceholderInUrl(href.toString()).replace(sites, "") || "/"
        }
        const internal = /^\/(?!\/)/.test(href?.toString() || "")

        // Use Link for internal links, and <a> for others
        if (internal && !external) {
            return (
                <NextLink
                    ref={ref}
                    prefetch={false}
                    href={href || "/"}
                    className="text-gray-dracula no-underline"
                    {...other}>
                    {children}
                </NextLink>
            )
        } else {
            return (
                <a ref={ref} className="text-gray-dracula no-underline" href={href?.toString()} {...other}>
                    {children}
                </a>
            )
        }
    }
)

Link.displayName = "Link"
